export enum TravelCreditAction {
  Add,
  Edit
}



// WEBPACK FOOTER //
// ./src/app/shared/models/travel-credit-action.ts